var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalemployers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 36C28 36 30 36 32 40C32 40 38.353 30 44 28",
    stroke: "#2E2D7E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44H13.1817C10.091 44 7.63262 42.496 5.42532 40.3932C0.906732 36.0882 8.3256 32.648 11.1551 30.9632C17.5118 27.1782 25.5058 27.0192 32 30.4864",
    stroke: "#2E2D7E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13C33 17.9706 28.9706 22 24 22C19.0294 22 15 17.9706 15 13C15 8.02944 19.0294 4 24 4C28.9706 4 33 8.02944 33 13Z",
    stroke: "#2E2D7E",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalemployers);
export default __webpack_public_path__ + "static/media/totalemployers.79ad7475440564a27a00f898bd68500c.svg";
export { ForwardRef as ReactComponent };